export const baseUrl = 'https://apigateway.nearpeer.org/trackingservice/v1/';